<script setup lang="ts">
import { computed } from 'vue'
import { getPermissionsAction } from '@/api/functions/access/get-permissions-action'
import { useQueryApi } from '@/composables/useApi'
import AccessOverview from './partials/AccessOverview.vue'

const tabs = [
  { title: 'اعضا', link: '/access' },
  { title: 'نقش‌ها', link: '/access/roles' },
  { title: 'مجوزها', link: '/access/permissions' },
]

const { data: permissionsData } = useQueryApi({
  queryKey: ['permissions'],
  queryFn: () => getPermissionsAction(),
  staleTime: 1000 * 60 * 3,
})

const columns = [
  { key: 'permissionName', label: 'نام مجوز', class: 'col-span-4 text-sm' },
  { key: 'description', label: 'توضیحات', class: 'col-span-8 text-sm' },
]

const permissions = computed(() => {
  const list = permissionsData.value?.data ?? []
  return list.map((p) => ({
    permissionName: p.label,
    description: p.description || '-',
  }))
})
</script>

<template>
    <div class="w-full mb-12">
        <AccessOverview :tabs="tabs" />

        <div class="mt-8">
            <Table :columns="columns" :rows="permissions" />
        </div>
    </div>
</template>
